import React from "react";
import ViewPropertyForm from "./ViewPropertyForm";

const ViewEditProperty = () => {
  return <ViewPropertyForm />;
};

export default ViewEditProperty;
